<template>
    <!-- :class="'bg-' + (theme === 'light' || theme === 'none' ? 'light text-dark' : `${theme} text-light`)" -->
    <footer
        class="p-2 mb-10 mt-10 bg-dark text-light"
    >

        <div class="mx-1 row row-cols-1 row-cols-sm-1 small">
            <div class="col-12 col-sm-10">
                <p
                    v-html="G.footerPowered"
                    class="m-0 text-light"
                    ></p>
                    <!-- :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`" -->
            </div>
            <!-- <div class="col-12 col-sm-2 d-sm-flex justify-content-start justify-content-sm-end mt-2 mt-sm-0">
                <ul class="list-unstyled d-flex m-0">
                    <li class=""><a class="" href="#"><i class="fab fa-google"></i></a></li>
                    <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                    <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                    <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                    <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                    <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                </ul>
            </div> -->
        </div>

    </footer>
</template>


<script>
import { G } from '@/_common';

export default {
    name: 'FooterSimple',
    props: {
        theme: {
            type: String,
            default: 'dark'
        },
    },
    setup() {
        return { G };
    },
}
</script>

<style lang="scss">
    .text-light > .footer-info-link{
        color: #ffffff;
    }
</style>